import { connect } from 'react-redux';

import ActionInputsList from 'app/developer-v3/pages/actions/ActionInputsList/ActionInputsList';
import { isCurrentAppDefinitionSaving } from 'app/developer-v3/selectors';

const mapStateToProps = state => ({
  isSaving: isCurrentAppDefinitionSaving(state),
});

export default connect(mapStateToProps)(ActionInputsList);
